import React from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from 'components/Modal';
import Instructions from 'components/modals/Instructions';
import Language from 'components/modals/Language';
import { useModal } from 'common/hooks';

function ModalSelector() {
  const modal = useModal();
  const navigate = useNavigate();

  const onClose = () => {
    navigate(-1);
  };

  if (!modal.id) {
    return null;
  }

  let modalContent;

  if (modal.id === 'instructions') {
    modalContent = <Instructions />;
  }

  if (modal.id === 'language') {
    modalContent = <Language />;
  }

  return <Modal onClose={onClose}>{modalContent}</Modal>;
}

export default ModalSelector;
